module.exports = "../../../../platform/assets/pageMainIcon/icon-renyuan-3-green.svg";